var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-timeline-item',{attrs:{"color":_vm.color},scopedSlots:_vm._u([(_vm.$scopedSlots.dot)?{key:"dot",fn:function(){return [_vm._t("dot")]},proxy:true}:null],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }